import { CollapsibleHeaderController } from '/Shared/CollapsibleHeader'
import { showPlaceModal, dismissPlaceModal } from '/Shared/PlaceModal'
import { dismissTourPitch } from '/Shared/TourPitch'
import { ProductDetailsContentController } from '/Shared/ProductDetailsContent'
import { 
	AppClipsCapability,
	appClipsCapability,
	DEBUG_delayNavigation
} from '../Constants'
import { 
	AppType,
	GLOBAL_AppPlatform,
	Metrics, 
	Page, 
	PitchType,
	Platform,
	TriggerPoint
} from '../Metrics'
import { ActionBar } from '/Shared/ActionBar'
import { initFloatingButton } from '/Shared/FloatingButton'

// Stash pitch state variables
let _stashPitchBackButtonHandler:((event:PopStateEvent) => void)|null = null
let _isDismissingStashPitchViaBackButton:boolean = false
let _isStashPitchDismissing:boolean = false
let _wasPlaceModalOpenBeforeStashPitch:boolean = false

let _productDetailsContentController:ProductDetailsContentController|null = null

function handleBackNavigation() {
	const currentURL:string = window.location.pathname
	const urlParts:string[] = currentURL.split( '/' )
	
	let region:string|null = null
	let subRegion:string|null = null
	
	if( urlParts.length >= 4 && urlParts[1] === 'explore' ){
		region = urlParts[2]
		subRegion = urlParts[3]
	}
	
	if( !region || !subRegion ){
		history.back()
		return
	}
	
	if( history.length <= 1 ){
		window.location.href = `/explore/${region}/${subRegion}`
		return
	}
	
	const referrer:string = document.referrer
	const expectedRegionURL:string = `/explore/${region}/${subRegion}`
	
	if( referrer && referrer.includes( expectedRegionURL )){
		history.back()
	} else {
		window.location.href = expectedRegionURL
	}
}

export function initProductDetailsPage() {
	const $navbar:JQuery<HTMLElement> = $('.collapsible-navbar')
	const $header:JQuery<HTMLElement> = $('.collapsible-header')
	
	if( $navbar.length === 0 || $header.length === 0 ){
		console.error( '❌ Required elements not found! Retrying in 500ms...' )
		setTimeout( () => initProductDetailsPage(), 500 )
		return
	}
	
	const pageCollapsibleController = new CollapsibleHeaderController( '.product-details-page', $(window) )
	const actionBar = new ActionBar( Page.AppPage )
	
	_productDetailsContentController = new ProductDetailsContentController({
		container: $('.product-details-page'),
		appTagline: 'Discover more with Happ',
		onItineraryStopClick: (placeID:string, placeName:string) => {
			void showPlaceModal(
				placeID,
				placeName,
				'Discover more with Happ',
				async (id:string) => {
					if( _productDetailsContentController )
						return await _productDetailsContentController.getPlaceDetails( id )
					throw new Error( 'ProductDetailsContentController not initialized' )
				},
				() => {
					pageCollapsibleController.enable()
				},
				actionBar,
				undefined,
				pageCollapsibleController
			)
		}
	})
	
	void _productDetailsContentController.initialize()
	const $window:JQuery<Window & typeof globalThis> = $(window)
	
	function handleRatingsScrollEffect() {
		const scrollTop:number = $window.scrollTop() || 0
		const scrollTriggerDistance:number = 30
		
		if( scrollTop > scrollTriggerDistance ){
			const scrollAmount:number = scrollTop - scrollTriggerDistance
			const $navbarRating:JQuery<HTMLElement> = $('#fixed-navigation .compact-rating')
			
			if( $navbarRating.length )
				$navbarRating.css( 'translate', `0 -${scrollAmount}px` )
		} else {
			const $navbarRating:JQuery<HTMLElement> = $('#fixed-navigation .compact-rating')
			if( $navbarRating.length )
				$navbarRating.css( 'translate', '0 0' )
		}
	}
	
	function handleBadgeVisibilityOnScroll(){
		const scrollTop:number = $window.scrollTop() || 0
		
		const $fixedNavForOffset:JQuery<HTMLElement> = $('.collapsible-navbar')
		const paddingTopStr:string = ($fixedNavForOffset.css( 'padding-top' ) || '0').toString()
		const paddingTop:number = parseInt( paddingTopStr, 10 )
		const scrollOffset:number = isNaN( paddingTop ) ? 0 : paddingTop
		
		let extraAdvancePx:number = 0
		if( $fixedNavForOffset.length > 0 && $fixedNavForOffset[0] instanceof Element ){
			try {
				const styles:CSSStyleDeclaration = getComputedStyle( $fixedNavForOffset[0] as Element )
				const extraStr:string = (styles.getPropertyValue( '--collapse-early-px' ) || '').trim()
				const parsed:number = parseInt( extraStr, 10 )
				extraAdvancePx = isNaN( parsed ) ? 0 : parsed
			} catch{ /* no-op */ }
		}
		
		const $header:JQuery<HTMLElement> = $('.collapsible-header')
		const headerHeight:number = $header.outerHeight() || 0
		const effectiveTitleScrollTop:number = scrollTop + scrollOffset + extraAdvancePx
		const maxMaskDistance:number = headerHeight - 96
		
		const $badge:JQuery<HTMLElement> = $('.collapsible-header .badge')
		
		if( effectiveTitleScrollTop >= maxMaskDistance ){
			$badge.addClass( 'hidden' )
		} else {
			$badge.removeClass( 'hidden' )
		}
	}
	
	const $desktopCTA = $('.desktop-cta-sidebar')
	let ctaTriggerTop:number = 0
	let $ctaSpacer:JQuery<HTMLElement>|null = null
	
	if( $desktopCTA.length ){
		const STICKY_OFFSET:number = 150
		
		setTimeout( () => {
			ctaTriggerTop = Math.max( 0, $desktopCTA.offset()?.top ?? 0 )
		}, 100 )
		
		$ctaSpacer = $('<div class="desktop-cta-spacer"></div>')
		const mediaQuery:MediaQueryList = window.matchMedia( '(min-width: 992px)' )
		
		$desktopCTA.after( $ctaSpacer )
	}
	
	function handleScroll(){
		handleRatingsScrollEffect()
		handleBadgeVisibilityOnScroll()
		
		if( $desktopCTA.length && $ctaSpacer ){
			const mediaQuery:MediaQueryList = window.matchMedia( '(min-width: 992px)' )
			if( !mediaQuery.matches ){
				return
			}
			const STICKY_OFFSET:number = 150
			const scrollTop:number = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0
			const shouldStick:boolean = (ctaTriggerTop - STICKY_OFFSET) <= scrollTop
			
			if( shouldStick ){
				if( !$desktopCTA.hasClass( 'is-stuck' ) ){
					const ctaOriginalWidth:number = $desktopCTA.outerWidth() ?? 0
					const ctaOriginalLeft:number = $desktopCTA.offset()?.left ?? 0
					
					$desktopCTA.addClass( 'is-stuck' )
					$desktopCTA.css({
						'top': '148px',
						'width': `${ctaOriginalWidth}px`,
						'left': `${ctaOriginalLeft}px`,
						'right': 'auto'
					})
					$ctaSpacer.css({
						'width': `${ctaOriginalWidth}px`,
						'height': `${$desktopCTA.outerHeight()}px`,
						'display': 'block'
					})
				}
				
				const $preFooter = $('.pre-footer')
				if( $preFooter.length ){
					const ctaBottom = ($desktopCTA.offset()?.top ?? 0) + ($desktopCTA.outerHeight() ?? 0)
					const preFooterTop = $preFooter.offset()?.top ?? 0
					
					if( ctaBottom >= preFooterTop ){
						$desktopCTA.addClass( 'is-hidden' )
					} else {
						$desktopCTA.removeClass( 'is-hidden' )
					}
				}
			} else {
				if( $desktopCTA.hasClass( 'is-stuck' )){
					$desktopCTA.removeClass( 'is-stuck is-hidden' )
					$desktopCTA.css({
						'top': '',
						'width': '',
						'left': '',
						'right': ''
					})
					$ctaSpacer.css( 'display', 'none' )
				}
			}
		}
	}
	
	$window.on( 'scroll', handleScroll )
	
	pageCollapsibleController.enable()
	handleBadgeVisibilityOnScroll()
	
	initFloatingButton({
		containerSelector: '.floating-cta-container',
		hideWhenReaches: '.pre-footer',
		scroller: window,
		autoHideStart: 'top bottom',
	})
	$(document).on( 'click', '#fixed-navigation .back-btn', event => {
		event.preventDefault()
		event.stopPropagation()
		handleBackNavigation()
	})
	
	// Wire up back button click handler to dismiss place modal
	$(document).on( 'click', '.back-btn', event => {
		const $target = $(event.target as HTMLElement)
		
		if( $target.closest( '#fixed-navigation' ).length )
			return
		
		const $dialog:JQuery<HTMLElement> = $('#placeSheet')
		const $backdrop:JQuery<HTMLElement> = $('#dialog-backdrop')
		dismissPlaceModal( $dialog, $backdrop )
	})
	
	//
		
	return () => {
		$window.off( 'scroll', handleScroll )
		pageCollapsibleController.disable()
		
		if( _productDetailsContentController ){
			_productDetailsContentController.destroy()
			_productDetailsContentController = null
		}
		
		const $navbarRating = $('#fixed-navigation .compact-rating')
		if( $navbarRating.length )
			$navbarRating.css( 'translate', '0 0' )
	}
}

// App launch functionality
async function launchApp( href:string, triggerPoint:TriggerPoint ){
	console.debug( `Launching app (HREF: ${href}, trigger: ${triggerPoint})...` )
	let appType:AppType = (appClipsCapability == AppClipsCapability.Full) ? AppType.Transient : AppType.Permanent
	const promises:Promise<any>[] = [] // NOTE(PERF): invoke in parallel
	if( GLOBAL_AppPlatform == Platform.iOS ){ // TEMP: workaround for Amplitude bug where filters are not respected when syncing
		const isPlaceModalOpen:boolean = $('#placeSheet').hasClass( 'is-visible' )
		const page:Page = (isPlaceModalOpen) ? Page.PlacePage : Page.AppPage
		promises.push( Metrics.logNAV_launchApp( appType, page, triggerPoint )) // NOTE: we can invoke this in parallel since the metrics logging is instant/synchronous, only the G-Tag upload is async
	}

	// navigate
	promises.push( Metrics.flush() ) // NOTE: ensure metrics are uploaded before navigating away
	promises.push( (DEBUG_delayNavigation) ?
		new Promise( resolve => setTimeout( resolve, 5000 ))
		: Promise.resolve()
	)
	await Promise.all( promises )
	window.location.href = href
}

// Stash pitch functionality
// star click handler
$('.star').on( 'click', function( event ){
	event.stopPropagation()
	
	// Check if place modal is open and hide it if necessary
	const isPlaceModalOpen:boolean = $('#placeSheet').hasClass( 'is-visible' )
	_wasPlaceModalOpenBeforeStashPitch = isPlaceModalOpen
	
	if( isPlaceModalOpen ){
		// Hide place modal without going through the full dismiss process
		const $dialog:JQuery<HTMLElement> = $('#placeSheet')
		const $backdrop:JQuery<HTMLElement> = $('#dialog-backdrop')
		$dialog.removeClass( 'is-visible' )
		if( $backdrop.length ){
			$backdrop.css( 'opacity', '0' )
		}
		$('#overlayable-area').removeClass( 'dimmed' )
	}
	
	const stashPitchContainer:JQuery<HTMLElement> = $('.stash-pitch-container')
	stashPitchContainer.addClass( 'visible' )
	stashPitchContainer.css( 'pointer-events', 'auto' )
	$('.stash-pitch-card').css( 'cursor', 'pointer' )
	$('#overlayable-area').addClass( 'blur' )
	$('.navbar-container').addClass( 'force-hidden' )
	
	$('body').css( 'overflow', 'hidden' )
	
	_stashPitchBackButtonHandler = (event:PopStateEvent) => {
		event.preventDefault()
		_isDismissingStashPitchViaBackButton = true
		dismissStashPitch()
	}
	
	window.addEventListener( 'popstate', _stashPitchBackButtonHandler )
	window.history.pushState({ stashPitchOpen: true }, '', window.location.href )
	
	const page:Page = _wasPlaceModalOpenBeforeStashPitch ? Page.PlacePage : Page.AppPage
	
	Metrics.logUI_pitchViewed( PitchType.Stash, page )
})

// action button click handler (for "Open in Happ" buttons)
$('.action-button:not(.tab-bar-container .action-button)').on( 'click', async event => {
	let ctaButton:JQuery<HTMLElement> = $(event.currentTarget)
	let href:string = ctaButton.attr( 'data-href' )

	const isStashOpen:boolean = $('.stash-pitch-container').hasClass( 'visible' )
	const isTourPitchOpen:boolean = $('.tour-pitch-container').hasClass( 'visible' )
	const triggerPoint:TriggerPoint = (isStashOpen || isTourPitchOpen) ? TriggerPoint.Pitch : TriggerPoint.SecondaryCTA

	await launchApp( href, triggerPoint )
})

// stash pitch card click handler for CTA
$('.stash-pitch-card').on( 'click', async _ => {
	let ctaButton:JQuery<HTMLElement> = $('.stash-pitch-container .action-button')
	let href:string = ctaButton.attr( 'data-href' )

	await launchApp( href, TriggerPoint.Pitch )
})

// keep browsing button click handler
$('.secondary-button').on( 'click', function( event ){
	event.stopPropagation()
	dismissStashPitch()
})

// tours pitch keep browsing button click handler
$('.tour-pitch-container .secondary-button').on( 'click', function( event ){
	event.stopPropagation()
	dismissTourPitch()
})

function dismissStashPitch() {
	_isStashPitchDismissing = true
	$('body').css( 'overflow', '' )

	const stashPitchContainer:JQuery<HTMLElement> = $('.stash-pitch-container')
	stashPitchContainer.addClass( 'hidden' )
	stashPitchContainer.css( 'pointer-events', 'none' )
	stashPitchContainer.css( 'cursor', 'default' )
	$('#overlayable-area').removeClass( 'blur' )
	$('.navbar-container').removeClass( 'force-hidden' )

	// Restore place modal if it was open before stash pitch
	if( _wasPlaceModalOpenBeforeStashPitch ){
		const $dialog:JQuery<HTMLElement> = $('#placeSheet')
		const $backdrop:JQuery<HTMLElement> = $('#dialog-backdrop')
		
		// Restore place modal visibility
		$dialog.addClass( 'is-visible' )
		if( $backdrop.length ){
			$backdrop.css( 'opacity', '1' )
		}
		$('#overlayable-area').addClass( 'dimmed' )
		
		_wasPlaceModalOpenBeforeStashPitch = false
	}

	if( _stashPitchBackButtonHandler ){
		window.removeEventListener( 'popstate', _stashPitchBackButtonHandler )
		_stashPitchBackButtonHandler = null
		if( !_isDismissingStashPitchViaBackButton ){
			const isPlaceModalOpen:boolean = $('#placeSheet').hasClass( 'is-visible' )
			if( !isPlaceModalOpen )
				window.history.back()
		}
		_isDismissingStashPitchViaBackButton = false
	}

	setTimeout( () => {
		$('.stash-pitch-container').removeClass( 'visible hidden' )
		_isStashPitchDismissing = false
	}, 300 )
}

$(document).ready( () => {
	setTimeout( () => {
		initProductDetailsPage()
	}, 100 )
})
